// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1VCKf","logo":"Header_logo__3_SJs","search":"Header_search__ckDys","avatar":"Header_avatar__2DnQ9","profileSection":"Header_profileSection__4EpQ_"};